package ru.it_mozaika.sender.js.application.routes

import ru.it_mozaika.sender.js.application.frames.subscribers.subscribersListFrame
import js.core.jso
import react.create
import react.router.RouteObject
import ru.it_mozaika.sender.js.application.context.*
import ru.it_mozaika.sender.js.application.frames.subscribers.AddSubscribersFrame
import ru.it_mozaika.sender.js.application.frames.subscribers.subscriberFrame

val subscribersRoutes = jso<RouteObject> {
    path = "subscribers"
    children = arrayOf(
        jso {
            path = ":id"
            element = SubscriptionListProvider.create {
                multiple = true
                SubscriberProvider {
                    PropertiesProvider {
                        subscriberFrame {}
                    }
                }
            }
        },
        jso {
            path = ""
            index = true
            element = SubscriptionListProvider.create {
                multiple = true
                TableProvider {
                    PropertiesProvider {
                        subscribersListFrame()
                    }
                }
            }
        },
        jso {
            path = "add"
            element = SubscriptionListProvider.create {
                multiple = true
                PropertiesProvider {
                    AddSubscribersStepperProvider { AddSubscribersFrame {} }
                }
            }
        }
    )
}
